import React, { useState, useEffect } from "react";
import LessonReportsList from "../../components/report/LessonReportsList";

const SESSION_KEY = "lesson_reports_list_state";

const AdminReportsPage = () => {
    const savedState = (() => {
        try {
            const saved = sessionStorage.getItem(SESSION_KEY);
            return saved ? JSON.parse(saved) : null;
        } catch {
            return null;
        }
    })();

    const [showUnconfirmedOnly, setShowUnconfirmedOnly] = useState(
        () => savedState?.showUnconfirmedOnly ?? true
    );
    const [showUnSuggestedOnly, setShowUnSuggestedOnly] = useState(
        () => savedState?.showUnSuggestedOnly ?? false
    );
    const [refresh, setRefresh] = useState(false); // 🔹 `refresh` ステートを追加

    // チェックボックス変更時に sessionStorage を更新
    useEffect(() => {
        try {
            const currentSaved = JSON.parse(sessionStorage.getItem(SESSION_KEY) || "{}");
            sessionStorage.setItem(
                SESSION_KEY,
                JSON.stringify({
                    ...currentSaved,
                    showUnconfirmedOnly,
                    showUnSuggestedOnly,
                })
            );
        } catch (e) {
            console.error(e);
        }
    }, [showUnconfirmedOnly, showUnSuggestedOnly]);

    return (
        <div className="p-3 pt-20">
            <h1 className="text-2xl font-bold mb-4">📝 報告書一覧</h1>

            {/* 🔹 未確認のみ表示ボタン */}
            <div className="mb-4">
                <label className="flex items-center space-x-2 cursor-pointer">
                    <input
                        type="checkbox"
                        className="w-5 h-5"
                        checked={showUnconfirmedOnly}
                        onChange={() => setShowUnconfirmedOnly(prev => !prev)}
                    />
                    <span className="text-lg">未確認の報告書のみ表示</span>
                </label>
            </div>

            <div className="mb-4">
                <label className="flex items-center space-x-2 cursor-pointer">
                    <input
                        type="checkbox"
                        className="w-5 h-5"
                        checked={showUnSuggestedOnly}
                        onChange={() => setShowUnSuggestedOnly(prev => !prev)}
                    />
                    <span className="text-lg">AI未提案の報告書のみ表示</span>
                </label>
            </div>


            {/* 🔹 報告書リスト */}
            <LessonReportsList
                isAdmin={true}
                showUnconfirmedOnly={showUnconfirmedOnly}
                showUnSuggestedOnly={showUnSuggestedOnly}
                refresh={refresh}
                setRefresh={setRefresh}
            />
        </div>
    );
};

export default AdminReportsPage;
